export default __webpack_public_path__ + "static/media/flesh2.e3ceac1e.png";